/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-logo.html";

/**
 * The ns-logo should be used for
 *
 * <h1>Logo</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-logo></ns-logo>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsLogo extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-logo";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  ready() {
    super.ready();
  }

  static get properties() {
    return {
      /**
       * Array of hex colors to cycle through
       * A single hex value will lock the color
       * Don't add the #
       */
      colors: {
        type: Array,
        value: [
          "color-expressive-1",
          "color-expressive-2",
          "color-expressive-3",
          "color-expressive-4",
          "color-expressive-5",
          "color-expressive-6",
          "color-expressive-7",
          "color-expressive-8"
        ],
        observer: "_randomizeColor"
      },
      /**
       * Href for the logo
       */
      linkUrl: String,
      /**
       * Prevents adaptive logo across breakpoints
       * Use 'simple', 'lockup', or 'lockup-stacked'
       */
      lock: String,
      /**
       * Forces entire logo to be one color
       */
      solid: Boolean,
      /**
       * Hides the logo
       */
      hidden: {
        type: Boolean,
        value: false
      },
      /**
       * Shows the 'lockup' logo instead of 'simple' logo (except if lock is used)
       */
      noSimpleLogo: {
        type: Boolean,
        value: true
      },
      /**
       * Defaults to using a smaller logo for 'lockup-stacked
       */
      small: {
        type: Boolean,
        value: true
      }
    };
  }

  _randomizeColor() {
    if (this.colors) {
      let color = this.colors[Math.floor(Math.random() * this.colors.length)];
      this.updateStyles({
        "--ns-logo-fill":
          color.length === 6 ? "#" + color : "var(--" + color + ")"
      });
    }
  }
}
customElements.define(NsLogo.is, NsLogo);
